import React from "react";
import { Link } from "react-router-dom";

function Sims() {
  return (
    <div>
      <section
        className="page-title"
        style={{
          backgroundImage: "url(../images/background/bg-page-title-1.jpg)",
        }}
      >
        <div className="auto-container">
          <h1>스마트 서비스</h1>
          <div className="bread-crumb-outer">
            <ul className="bread-crumb clearfix">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="active">SIMS</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="feature-style-1">
        <div className="auto-container">
          <div className="row clearfix">
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 company">
              <div className="company-tab">
                <ul className="nav nav-pills nav-justified">
                  <li>
                    <Link data-toggle="pill" to="/smartcity">
                      스마트시티서비스{" "}
                    </Link>
                  </li>
                  <li>
                    <Link data-toggle="pill" to="/safe">
                      안전 플랫폼{" "}
                    </Link>
                  </li>
                  <li className="active">
                    <Link data-toggle="pill" to="/sims">
                      SIMS{"  "}
                    </Link>
                  </li>
                </ul>
                <div className="tab-content">
                        <div className='tab_content_area'>
                            <div className="tab_title">
                                서버 정보 관리 시스템(SIMS)
                            </div>
                            <div className='tab_paragraph'>
                                <p>개요</p>
                                <div className='tab_brackets'></div>
                                    <ul>
                                        <li>- 서비스운영 센터의 H/W, S/W 정보를 IP기반 연결로 자동 수집해 자산 현행화를 유지하고, 수집된 데이터 필터링 및 분석으로 운용 자산을 효율적으로 관리하기 위한 솔루션</li>
                                        <li>- 수집된 데이터를 기반으로 빅데이터, AI 분석의 기초 자료로 활용될 수 있으며 고장, 장애 예측과 같은 실질적인 자산 관리 서비스 제공 가능</li>
                                    </ul>
                            </div>
                            <div className='tab_paragraph'>
                                <p>특장점</p>
                                <div className='tab_brackets'></div>
                                    <ul>
                                        <li>- Linux/Unix 기반 서버에 SSH Key 방식으로 접속</li>
                                        <li>- Public Key 설치 서버에 접속하여 스크립트 배포, 실행, 수집, 파싱 수행</li>
                                        <li>- sudoers에 명시된 명령어만 실행 가능하여 위험 명령 수행 방지</li>
                                        <li>- 수집된 정보로부터 서버 버전 관리, 디스크, 메모리 등 자원 정보 확인 가능</li>
                                        <li>- 필요시 사용자 작성 스크립트 수행 기능</li>
                                        <li>- 다수 서버의 H/W, S/W 및 자원 정보를 스케줄, SMS, E-mail을 통해 관리 가능</li>
                                    </ul>
                                    <div className='simsPost1'>
                                        <div className='servicePostCard7'>
                                                <p className='cardname2'>SIMS gathering flow</p>
                                                <div style={{display:'flex',justifyContent:'center'}}>
                                                    <div><img src='./images/service/Data/image40.png' alt='' /><br/><b>SIMS</b></div>
                                                    <div>
                                                        <li><p>Shell script scp send</p></li>
                                                        <li><img src='./images/service/Data/arrow3.png' alt=''/></li>
                                                        <li><p>Shell script running</p></li>
                                                        <li><img src='./images/service/Data/arrow3.png' alt=''/></li>
                                                        <li><p>Shell script output file get (scp&sftp)</p></li>
                                                        <li><img src='./images/service/Data/arrow4.png' alt=''/></li>
                                                        <li><p>Output file parsing</p></li>
                                                    </div>
                                                    <div><img src='./images/service/Data/image41.png' alt=''/><br/><b>H/W</b></div>
                                                </div>
                                        </div>
                                        <div className='diagram'>
                                            <div className='namecircle2'>
                                            <div className='namecircle1' style={{top:'-50px', right:'90px'}}>보안장비</div>
                                            <div className='namecircle1' style={{top:'10px',left:'-20px'}}>스토리지</div>
                                            <div className='namecircle1' style={{top:'120px', left:'-45px'}}>교환기 및<br/>부대시설</div>
                                            <div className='namecircle1' style={{bottom:'-40px',left:'25px'}}>IP 장비</div>
                                            <div className='namecircle1' style={{bottom:'-40px',right:'35px'}}>SW</div>
                                            <div className='namecircle1' style={{top:'120px', right:'-45px'}}>VM</div>
                                            <div className='namecircle1' style={{top:'10px',right:'-20px'}}>서버</div>
                                            <div className='namecircle3'>SIMS<br/>관리대상</div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            <div className='tab_paragraph'>
                                <p>제공 기능</p>
                                <div className='tab_brackets'></div>
                                 
                                <div className='tab_table3'>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th scope='col'><center>기능</center></th>
                                                <th scope='col'><center>설명</center></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope="row" className='data1'><center>자동수집</center></th>
                                                <td>IP기반 대상 장비에 SSH 접속하여 각종 H/W 정보 수집</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className='data1'><center>현행화 및 대사율 관리</center></th>
                                                <td>사용자 등록 및 수집 data 기반으로 현행화/대사율 관리 제공</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className='data1'><center>권고 버전 관리</center></th>
                                                <td>권고 버전 표준안과 비교하여 취약 버전 알람</td>
                                            </tr>
                                            <tr>
                                                <th scope="row" className='data1'><center>사용자 편의 data 제공</center></th>
                                                <td>비교/대조 등 사용자 필요에 따른 data 관리 편의성을 제공</td>
                                            </tr>
                                        </tbody>
                                    </table>
                              </div>
                            </div>
                            <div className='tab_paragraph'>
                                <p>적용 사례</p>
                                <div className='tab_brackets'></div>
                                    <ul>
                                        <li>- SKT 서버 6천대 이상 관리에 적용</li>
                                    </ul>
                                    <div className='servicePostBox5'>
                                        <div   className='servicePostCard8'>
                                            <img src='./images/service/Data/image42.png' alt=''/><br/>
                                            <b>스크립트 수행 작업 등록 및 수집 현황</b>
                                        </div>
                                        <div   className='servicePostCard8'>
                                            <img src='./images/service/Data/image43.png' alt=''/><br/>
                                            <b>스크립트 수행 결과 조회</b>
                                        </div>
                                    </div>
                            </div>
                        </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default Sims;
